/*
  Ersin Hoca – örnek dersler
  - Kurs sekmeleri (#bağlantı ile doğrudan açılabilir)
  - Tıklayınca yüklenen video oynatıcı (Vimeo / YouTube)
  - "İzledim" ilerlemesi localStorage'da (eski bölümle aynı anahtar ve biçim: { "reading-1": true })
  JS yoksa tüm kurslar alt alta görünür, videolar yeni sekmede açılır.
*/
(function () {
  'use strict';
  if (window.EHLessons) return;

  var thumbCache = {};

  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  function fmt(sec) {
    sec = Math.round(sec || 0);
    if (!sec) return '';
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    var ss = (s < 10 ? '0' : '') + s;
    return h ? h + ':' + (m < 10 ? '0' : '') + m + ':' + ss : m + ':' + ss;
  }

  function vimeoInfo(id) {
    if (!thumbCache[id]) {
      var url = 'https://vimeo.com/api/oembed.json?width=1280&url=' + encodeURIComponent('https://vimeo.com/' + id);
      thumbCache[id] = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return thumbCache[id];
  }

  function init(root) {
    if (!root || root.__ehLessonsInit) return;
    root.__ehLessonsInit = true;

    var tabs = [].slice.call(root.querySelectorAll('[data-eh-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-eh-panel]'));
    var videos = [].slice.call(root.querySelectorAll('[data-eh-video]'));
    var progressBox = root.querySelector('[data-eh-lprogress]');
    var doneEl = root.querySelector('[data-eh-done]');
    var sheet = root.querySelector('[data-eh-lsheet]');
    var resumeBtn = root.querySelector('[data-eh-resume]');
    var resetBtn = root.querySelector('[data-eh-reset]');
    var storageKey = root.getAttribute('data-storage-key') || 'ersin-hoca-ornek-dersler-progress-v1';
    var activeKey = root.getAttribute('data-active-key') || 'ersin-hoca-ornek-dersler-active-v1';
    if (!panels.length) return;

    var progress = {};
    try { progress = JSON.parse(store(storageKey)) || {}; } catch (e) { progress = {}; }

    var bubbles = [];
    if (sheet) {
      sheet.innerHTML = '';
      videos.forEach(function () {
        var b = document.createElement('i');
        b.className = 'eh-bubble';
        sheet.appendChild(b);
        bubbles.push(b);
      });
    }

    function isDone(v) { return progress[v.getAttribute('data-eh-video')] === true; }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var intro = !reduce; // ilk açılışta balonlar sırayla dolar, sayı sayarak artar

    function countTo(n) {
      if (!doneEl) return;
      var from = parseInt(doneEl.textContent, 10) || 0;
      if (reduce || from === n) { doneEl.textContent = n; return; }
      var t0 = null;
      var step = function (t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / 700);
        doneEl.textContent = Math.round(from + (n - from) * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    function render() {
      var done = 0;
      var filledIndex = 0;
      videos.forEach(function (v, i) {
        var on = isDone(v);
        if (on) done++;
        var btn = v.querySelector('[data-eh-done-toggle]');
        if (btn) {
          btn.hidden = false;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          var bub = btn.querySelector('.eh-bubble');
          if (bub) bub.classList.toggle('is-filled', on);
        }
        if (bubbles[i] && !intro) bubbles[i].classList.toggle('is-filled', on);
        if (bubbles[i] && intro && on) {
          bubbles[i].style.setProperty('--d', (filledIndex++ * 90) + 'ms');
        }
      });
      panels.forEach(function (p, i) {
        var tab = tabs[i];
        if (!tab) return;
        var dots = tab.querySelectorAll('.eh-ltab__dot');
        [].slice.call(p.querySelectorAll('[data-eh-video]')).forEach(function (v, j) {
          if (dots[j]) dots[j].classList.toggle('is-filled', isDone(v));
        });
      });
      if (!intro) countTo(done);
      if (resetBtn) resetBtn.hidden = done === 0;
      return done;
    }

    function playIntro(done) {
      // Sayfa açılınca: balonlar soldan sağa sırayla işaretlenir
      setTimeout(function () {
        intro = false;
        render();
        setTimeout(function () {
          bubbles.forEach(function (b) { b.style.removeProperty('--d'); });
        }, 1600);
      }, 350);
    }

    function save() {
      try { store(storageKey, JSON.stringify(progress)); } catch (e) {}
    }

    /* ---------- Oynatıcı ---------- */
    function stop(player) {
      var frame = player.querySelector('iframe');
      if (frame && player.__facade) {
        player.removeChild(frame);
        player.appendChild(player.__facade);
      }
    }

    function stopAll(except) {
      [].slice.call(root.querySelectorAll('.eh-lvid__player')).forEach(function (p) {
        if (p !== except) stop(p);
      });
    }

    function play(facade) {
      var player = facade.parentNode;
      var host = facade.getAttribute('data-host');
      var id = facade.getAttribute('data-id');
      var src = host === 'youtube'
        ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1'
        : 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0&portrait=0&dnt=1';
      stopAll(player);
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.title = facade.getAttribute('data-title') || 'Video';
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      player.__facade = facade;
      player.removeChild(facade);
      player.appendChild(frame);
      frame.focus();
    }

    function loadThumbs(panel) {
      [].slice.call(panel.querySelectorAll('[data-eh-play][data-host="vimeo"]')).forEach(function (f) {
        var img = f.querySelector('[data-eh-thumb]');
        var dur = f.querySelector('[data-eh-dur]');
        var needDur = dur && !dur.textContent.trim();
        if (!img && !needDur) return;
        if (f.__thumbAsked) return;
        f.__thumbAsked = true;
        vimeoInfo(f.getAttribute('data-id')).then(function (j) {
          if (!j) return;
          if (img && j.thumbnail_url) {
            img.onload = function () { img.hidden = false; };
            img.src = j.thumbnail_url;
          }
          if (needDur && j.duration) {
            dur.textContent = fmt(j.duration);
            dur.hidden = false;
          }
        });
      });
    }

    /* ---------- Sekmeler ---------- */
    var current = -1;

    function activate(i, opts) {
      opts = opts || {};
      if (i < 0 || i >= panels.length) i = 0;
      var changed = i !== current;
      current = i;
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.setAttribute('tabindex', j === i ? '0' : '-1');
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        if (!on) {
          [].slice.call(p.querySelectorAll('.eh-lvid__player')).forEach(stop);
        }
        p.hidden = !on;
        if (on && changed && opts.animate) {
          p.classList.remove('is-entering');
          void p.offsetWidth;
          p.classList.add('is-entering');
        }
      });
      loadThumbs(panels[i]);
      store(activeKey, String(i));
      if (opts.hash && window.history && history.replaceState) {
        history.replaceState(null, '', '#' + panels[i].getAttribute('data-anchor'));
      }
      if (opts.scroll) {
        var top = panels[i].getBoundingClientRect().top;
        if (top < 80 || top > window.innerHeight * 0.6) {
          window.scrollTo({ top: window.pageYOffset + top - 110, behavior: opts.smooth === false ? 'auto' : 'smooth' });
        }
      }
      // Seçili sekmeyi mobil çip şeridinde görünür tut
      var tab = tabs[i];
      if (tab && tab.parentNode && tab.parentNode.scrollWidth > tab.parentNode.clientWidth) {
        var strip = tab.parentNode;
        strip.scrollTo({ left: tab.offsetLeft - strip.clientWidth / 2 + tab.offsetWidth / 2, behavior: 'smooth' });
      }
    }

    function indexFromHash() {
      var h = decodeURIComponent((location.hash || '').replace('#', '')).toLowerCase();
      if (!h) return -1;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-anchor') === h) return i;
      }
      return -1;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        activate(i, { hash: true, animate: true, scroll: window.innerWidth >= 990 });
      });
      t.addEventListener('keydown', function (e) {
        var k = e.key;
        var next = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') next = (i + 1) % tabs.length;
        if (k === 'ArrowUp' || k === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (k === 'Home') next = 0;
        if (k === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        activate(next, { hash: true, animate: true });
        tabs[next].focus();
      });
    });

    root.addEventListener('click', function (e) {
      var f = e.target.closest && e.target.closest('[data-eh-play]');
      if (f && root.contains(f)) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return; // yeni sekmede açmak isteyene dokunma
        e.preventDefault();
        play(f);
        return;
      }
      var d = e.target.closest && e.target.closest('[data-eh-done-toggle]');
      if (d && root.contains(d)) {
        var v = d.closest('[data-eh-video]');
        var id = v.getAttribute('data-eh-video');
        if (progress[id] === true) delete progress[id];
        else progress[id] = true;
        save();
        render();
      }
    });

    if (resumeBtn) {
      resumeBtn.addEventListener('click', function () {
        var target = null;
        for (var i = 0; i < videos.length; i++) {
          if (!isDone(videos[i])) { target = videos[i]; break; }
        }
        target = target || videos[0];
        if (!target) return;
        var panel = target.closest('[data-eh-panel]');
        activate(panels.indexOf(panel), { hash: true, animate: true });
        var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
        window.scrollTo({ top: top, behavior: 'smooth' });
        var f = target.querySelector('[data-eh-play]');
        if (f) f.focus({ preventScroll: true });
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        progress = {};
        save();
        render();
      });
    }

    window.addEventListener('hashchange', function () {
      var h = indexFromHash();
      if (h !== -1 && h !== current) activate(h, { animate: true, scroll: true });
    });

    // Başlangıç: önce #bağlantı, sonra son açılan kurs, yoksa ilk kurs
    var start = indexFromHash();
    var fromHash = start !== -1;
    if (!fromHash) {
      var saved = parseInt(store(activeKey), 10);
      start = isNaN(saved) ? 0 : saved;
    }
    root.classList.add('is-ready');
    if (progressBox) progressBox.hidden = false;
    playIntro(render());
    activate(start, { scroll: fromHash, smooth: false });
  }

  function initAll(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-eh-lessons]')).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    // Tema düzenleyicisinde seçilen kurs/video bloğunun panelini aç
    var el = e.target;
    var root = el.closest && el.closest('[data-eh-lessons]');
    if (!root) return;
    var tab = el.closest('[data-eh-tab]');
    var panel = el.closest('[data-eh-panel]');
    if (tab) tab.click();
    else if (panel) {
      var t = root.querySelector('[aria-controls="' + panel.id + '"]');
      if (t) t.click();
    }
  });
  window.EHLessons = { init: initAll };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
